import { render } from "./trafficModal.vue?vue&type=template&id=4963039c&scoped=true"
import script from "./trafficModal.vue?vue&type=script&lang=js"
export * from "./trafficModal.vue?vue&type=script&lang=js"

import "./trafficModal.vue?vue&type=style&index=0&id=4963039c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4963039c"]])

export default __exports__